import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CategoriesMain from "../Components/Categories/categoriesMain";
import AddCategories from "../Components/Categories/addCategories";
import EditCategories from "../Components/Categories/editCategories";
import AddSubCategories from "../Components/Categories/addSubCategories";
import EditSubCategories from "../Components/Categories/editSubCategory";
import ViewCategory from "../Components/Categories/viewCategory";

const CategoriesRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route path="/categories" element={<CategoriesMain />}></Route>
      <Route path="/categories/add" element={canAdd ? <AddCategories /> : <Navigate to="/categories" replace /> }></Route>
      <Route path="/categories/edit/:id" element={canEdit ? <EditCategories /> : <Navigate to="/categories" replace />}></Route>
      <Route
        path="/categories/:id/sub/add"
        element={<AddSubCategories />}
      ></Route>
      <Route
        path="/categories/view/:id"
        element={<ViewCategory />}
      ></Route>
      <Route
        path="/categories/view/sub/edit/:id"
        element={<EditSubCategories />}
      ></Route>
    </Routes>
  );
};

export default CategoriesRoutes;
